import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_IS_SERVICES_ENABLED = 'PUBLISH_TERMS :: CHANGE_IS_SERVICES_ENABLED';

export type TChangeIsServicesEnabledAction = IReduxAction<typeof CHANGE_IS_SERVICES_ENABLED, boolean>;

export const changeIsServicesEnabled = actionGenerator<typeof CHANGE_IS_SERVICES_ENABLED, boolean>(
  CHANGE_IS_SERVICES_ENABLED,
);
